import { colors, fonts, fontSizes, measurements } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .dashboard-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .events {
    display: flex;
    flex-flow: column;
  }
  .events div{
    display: flex;
    background: white;
    padding: 1rem;
    justify-content: space-between;
    margin: .5rem 0;
  }
  .events div strong {
    color: ${colors.text};
  }
  .events div strong span{
    font-weight: lighter;
    font-size: 1rem;
    color: ${colors.darkGray};
  }
`

export const container = css`
  .container {
    display: flex;
    width: 100%;
    max-width: ${measurements.containerSize};
    flex-wrap: wrap;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .container > header {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h5};
    width: 100%;
    margin: 2rem 0;
  }

  @media screen and (min-width: 1200px) {
    .container {
      justify-content: space-evenly;
      max-width: ${measurements.containerLargeSize};
    }
  }
`
